import React from 'react'
import NotFoundFilter from '../components/NotFoundFilter';

const NotFoundFilters = () => {
  return (<NotFoundFilter />)
}

export default NotFoundFilters
